<span
  class="px-2 inline-flex text-xs leading-5 rounded border border-cinza"
  [ngClass]="variant() == 'primary' ? 'bg-primary text-white' : 'text-primary'"
>
  {{ texto() }}
</span>
